import React from 'react'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

export const getColumns = (onEdit) => [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Temperature',
    dataIndex: 'temperature',
    key: 'temperature',
    render: (value) => (value !== null && value !== undefined ? value : '-'),
  },
  {
    title: 'Max Tokens',
    dataIndex: 'max_output_tokens',
    key: 'max_output_tokens',
    render: (value) => (value !== null && value !== undefined ? value : '-'),
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 100,
    render: (_, record) => (
      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() => onEdit(record)}
        size="small"
      >
        Edit
      </Button>
    ),
  },
]
